import type { HubPersona, FavoriteEntity } from '../../../shared';

// Mapping an email address of a persona (email if Person, listOriginalDisplayName if PrivateDistributionList)
// to PDL.personaId's of all related PDLs (= PDLs having a member with this email address)
export type EmailToPDLsMapType = { [emailAddress: string]: string[] };

export interface EmailToPDLsMapState {
    readonly emailToPDLsMap: EmailToPDLsMapType;
    readonly emailToAddedPDLPersonaIdsWaitingForUpdate: EmailToPDLsMapType;
    readonly emailToRemovedPDLPersonaIdsWaitingForUpdate: EmailToPDLsMapType;
}

export interface SuggestedPersonasState {
    readonly personas: HubPersona[];
    readonly isLoading: boolean;
    readonly isError: boolean;
}

export interface CurrentNavigationPersonaState {
    readonly currentPersona?: HubPersona;
}

export interface DeletedPersonasState {
    readonly deletedPersonas: HubPersona[];
    readonly recoverablePersonas: HubPersona[];
    readonly isLoading: boolean;
    readonly isError: boolean;
}

export interface FavoritePersonsState {
    readonly favoritePersons: FavoriteEntity[];
    readonly areInitialFavoritesLoaded: boolean;
    readonly favoriteIdsBeingRemoved: string[];
    readonly isFavoritingInProgress: boolean;
}

export interface HubState {
    readonly favoritePersonsState: FavoritePersonsState;
    readonly suggestedPersonasState: SuggestedPersonasState;
    readonly deletedPersonasState: DeletedPersonasState;
    readonly currentNavigationPersonaState: CurrentNavigationPersonaState;
    readonly emailToPDLsMapState: EmailToPDLsMapState;
}

export const packageStateKey = 'hubdata';
